import { useEffect, useRef } from "react";

export default function useScrollRestore(key, ready = true) {
    const restoredRef = useRef(false);

    // RESTAURA
    useEffect(() => {
        if (!ready) return;
        if (restoredRef.current) return;

        const saved = sessionStorage.getItem(key);
        if (!saved) return;

        const y = parseInt(saved, 10);

        // setTimeout em vez de requestAnimationFrame: rAF só dispara em sync
        // com um novo frame de composição, que pode nunca chegar em abas em
        // segundo plano ou alguns contextos de preview/automação.
        const id = setTimeout(() => {
            window.scrollTo({ top: y, behavior: "auto" });
            restoredRef.current = true;
            sessionStorage.removeItem(key);
        }, 0);

        return () => clearTimeout(id);
    }, [ready, key]);

    // SALVA
    const saveScroll = () => {
        sessionStorage.setItem(key, window.scrollY);
    };

    return saveScroll;
}